import _slicedToArray from "/var/jenkins_home/workspace/tingle.f418dd7e-8301-4eb7-bd6c-ad3162510800/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "/var/jenkins_home/workspace/tingle.f418dd7e-8301-4eb7-bd6c-ad3162510800/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "/var/jenkins_home/workspace/tingle.f418dd7e-8301-4eb7-bd6c-ad3162510800/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "/var/jenkins_home/workspace/tingle.f418dd7e-8301-4eb7-bd6c-ad3162510800/workspace/node_modules/next/node_modules/@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// ignore-string-externalization
import { loadCategory, loadFaq, loadHome, loadRelatedCategory } from './loaders';

var hasUrlSlug = function hasUrlSlug(categorySlug) {
  return function (category) {
    return category.urlSlug === categorySlug;
  };
};

var hasArticle = function hasArticle(articleSlug) {
  return function (category) {
    return category.faqs.find(function (article) {
      return article.urlSlug === articleSlug;
    });
  };
};

var attachFaqCategory = function attachFaqCategory(items, template, smartlingLanguage, preview) {
  return Promise.all(items.map(function (item) {
    var _template$faqCategori;

    if (item.contentType !== 'faq') {
      return item;
    }

    var categoryFromHelpHome = (_template$faqCategori = template.faqCategories) === null || _template$faqCategori === void 0 ? void 0 : _template$faqCategori.find(hasArticle(item.urlSlug));
    return (categoryFromHelpHome ? Promise.resolve(categoryFromHelpHome) : loadRelatedCategory({
      key: item.id,
      preview: preview,
      smartlingLanguage: smartlingLanguage
    })).then(function (category) {
      return _objectSpread(_objectSpread({}, item), {}, {
        category: category
      });
    });
  }));
};

export var getHomePageData = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(preview, smartlingLanguage) {
    var template;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return loadHome({
              preview: preview,
              smartlingLanguage: smartlingLanguage
            });

          case 2:
            template = _context.sent;
            return _context.abrupt("return", {
              template: template,
              preview: preview
            });

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getHomePageData(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
export var getArticlePageData = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(articleSlug, preview, smartlingLanguage, categorySlug) {
    var _template$faqCategori2, _template$faqCategori3;

    var _yield$Promise$all, _yield$Promise$all2, template, faq, categoryFromHelpHome, _yield$Promise$all3, _yield$Promise$all4, category, related;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return Promise.all([loadHome({
              preview: preview,
              smartlingLanguage: smartlingLanguage
            }), loadFaq({
              key: articleSlug,
              preview: preview,
              smartlingLanguage: smartlingLanguage
            })]);

          case 2:
            _yield$Promise$all = _context2.sent;
            _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
            template = _yield$Promise$all2[0];
            faq = _yield$Promise$all2[1];

            if (!(!faq || !template)) {
              _context2.next = 8;
              break;
            }

            return _context2.abrupt("return", {});

          case 8:
            categoryFromHelpHome = categorySlug ? template === null || template === void 0 ? void 0 : (_template$faqCategori2 = template.faqCategories) === null || _template$faqCategori2 === void 0 ? void 0 : _template$faqCategori2.find(hasUrlSlug(categorySlug)) : template === null || template === void 0 ? void 0 : (_template$faqCategori3 = template.faqCategories) === null || _template$faqCategori3 === void 0 ? void 0 : _template$faqCategori3.find(hasArticle(faq.urlSlug));
            _context2.next = 11;
            return Promise.all([categoryFromHelpHome || (categorySlug ? loadCategory({
              key: categorySlug,
              preview: preview,
              smartlingLanguage: smartlingLanguage
            }) : loadRelatedCategory({
              key: faq.id,
              preview: preview,
              smartlingLanguage: smartlingLanguage
            })), attachFaqCategory(faq.related || [], template, smartlingLanguage, preview)]);

          case 11:
            _yield$Promise$all3 = _context2.sent;
            _yield$Promise$all4 = _slicedToArray(_yield$Promise$all3, 2);
            category = _yield$Promise$all4[0];
            related = _yield$Promise$all4[1];
            return _context2.abrupt("return", {
              template: template,
              faq: _objectSpread(_objectSpread({}, faq), {}, {
                related: related
              }),
              category: category,
              preview: preview
            });

          case 16:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getArticlePageData(_x3, _x4, _x5, _x6) {
    return _ref2.apply(this, arguments);
  };
}();
export var getCategoryPageData = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(categorySlug, preview, smartlingLanguage) {
    var _yield$Promise$all5, _yield$Promise$all6, template, category;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return Promise.all([loadHome({
              preview: preview,
              smartlingLanguage: smartlingLanguage
            }), loadCategory({
              key: categorySlug,
              preview: preview,
              smartlingLanguage: smartlingLanguage
            })]);

          case 2:
            _yield$Promise$all5 = _context3.sent;
            _yield$Promise$all6 = _slicedToArray(_yield$Promise$all5, 2);
            template = _yield$Promise$all6[0];
            category = _yield$Promise$all6[1];
            return _context3.abrupt("return", {
              template: template,
              category: category,
              preview: preview
            });

          case 7:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function getCategoryPageData(_x7, _x8, _x9) {
    return _ref3.apply(this, arguments);
  };
}();